export const countryCodesArr = [
  {
    value: '+971',
    label: 'United Arab Emirates(‫الإمارات العربية المتحدة‬‎)',
    code: 'ae',
  },
  {
    value: '+966',
    label: 'Saudi Arabia(‫المملكة العربية السعودية‬‎)',
    code: 'sa',
  },
  {
    value: '+93',
    label: 'Afghanistan',
    code: 'af',
  },
  {
    value: '+358',
    label: 'Åland Islands',
    code: 'ax',
  },
  {
    value: '+355',
    label: 'Albania',
    code: 'al',
  },
  {
    value: '+213',
    label: 'Algeria',
    code: 'dz',
  },
  {
    value: '+1684',
    label: 'American Samoa',
    code: 'as',
  },
  {
    value: '+376',
    label: 'Andorra',
    code: 'ad',
  },
  {
    value: '+244',
    label: 'Angola',
    code: 'ao',
  },
  {
    value: '+1264',
    label: 'Anguilla',
    code: 'ai',
  },
  {
    value: '+672',
    label: 'Antarctica',
    code: 'aq',
  },
  {
    value: '+1268',
    label: 'Antigua and Barbuda',
    code: 'ag',
  },
  {
    value: '+54',
    label: 'Argentina',
    code: 'ar',
  },
  {
    value: '+374',
    label: 'Armenia',
    code: 'am',
  },
  {
    value: '+297',
    label: 'Aruba',
    code: 'aw',
  },
  {
    value: '+61',
    label: 'Australia',
    code: 'au',
  },
  {
    value: '+43',
    label: 'Austria',
    code: 'at',
  },
  {
    value: '+994',
    label: 'Azerbaijan',
    code: 'az',
  },
  {
    value: '+1242',
    label: 'Bahamas',
    code: 'bs',
  },
  {
    value: '+973',
    label: 'Bahrain',
    code: 'bh',
  },
  {
    value: '+880',
    label: 'Bangladesh',
    code: 'bd',
  },
  {
    value: '+1246',
    label: 'Barbados',
    code: 'bb',
  },
  {
    value: '+375',
    label: 'Belarus',
    code: 'by',
  },
  {
    value: '+32',
    label: 'Belgium',
    code: 'be',
  },
  {
    value: '+501',
    label: 'Belize',
    code: 'bz',
  },
  {
    value: '+229',
    label: 'Benin',
    code: 'bj',
  },
  {
    value: '+1441',
    label: 'Bermuda',
    code: 'bm',
  },
  {
    value: '+975',
    label: 'Bhutan',
    code: 'bt',
  },
  {
    value: '+591',
    label: 'Bolivia, Plurinational State of bolivia',
    code: 'bo',
  },
  {
    value: '+387',
    label: 'Bosnia and Herzegovina',
    code: 'ba',
  },
  {
    value: '+267',
    label: 'Botswana',
    code: 'bw',
  },
  {
    value: '+47',
    label: 'Bouvet Island',
    code: 'bv',
  },
  {
    value: '+55',
    label: 'Brazil',
    code: 'br',
  },
  {
    value: '+246',
    label: 'British Indian Ocean Territory',
    code: 'io',
  },
  {
    value: '+673',
    label: 'Brunei Darussalam',
    code: 'bn',
  },
  {
    value: '+359',
    label: 'Bulgaria',
    code: 'bg',
  },
  {
    value: '+226',
    label: 'Burkina Faso',
    code: 'bf',
  },
  {
    value: '+257',
    label: 'Burundi',
    code: 'bi',
  },
  {
    value: '+855',
    label: 'Cambodia',
    code: 'kh',
  },
  {
    value: '+237',
    label: 'Cameroon',
    code: 'cm',
  },
  {
    value: '+1',
    label: 'Canada',
    code: 'ca',
  },
  {
    value: '+238',
    label: 'Cape Verde',
    code: 'cv',
  },
  {
    value: '+345',
    label: 'Cayman Islands',
    code: 'ky',
  },
  {
    value: '+236',
    label: 'Central African Republic',
    code: 'cf',
  },
  {
    value: '+235',
    label: 'Chad',
    code: 'td',
  },
  {
    value: '+56',
    label: 'Chile',
    code: 'cl',
  },
  {
    value: '+86',
    label: 'China',
    code: 'cn',
  },
  {
    value: '+61',
    label: 'Christmas Island',
    code: 'cx',
  },
  {
    value: '+61',
    label: 'Cocos (Keeling) Islands',
    code: 'cc',
  },
  {
    value: '+57',
    label: 'Colombia',
    code: 'co',
  },
  {
    value: '+269',
    label: 'Comoros',
    code: 'km',
  },
  {
    value: '+242',
    label: 'Congo',
    code: 'cg',
  },
  {
    value: '+243',
    label: 'Congo, The Democratic Republic of the Congo',
    code: 'cd',
  },
  {
    value: '+682',
    label: 'Cook Islands',
    code: 'ck',
  },
  {
    value: '+506',
    label: 'Costa Rica',
    code: 'cr',
  },
  {
    value: '+225',
    label: "Cote d'Ivoire",
    code: 'ci',
  },
  {
    value: '+385',
    label: 'Croatia',
    code: 'hr',
  },
  {
    value: '+53',
    label: 'Cuba',
    code: 'cu',
  },
  {
    value: '+357',
    label: 'Cyprus',
    code: 'cy',
  },
  {
    value: '+420',
    label: 'Czech Republic',
    code: 'cz',
  },
  {
    value: '+45',
    label: 'Denmark',
    code: 'dk',
  },
  {
    value: '+253',
    label: 'Djibouti',
    code: 'dj',
  },
  {
    value: '+1767',
    label: 'Dominica',
    code: 'dm',
  },
  {
    value: '+1849',
    label: 'Dominican Republic',
    code: 'do',
  },
  {
    value: '+593',
    label: 'Ecuador',
    code: 'ec',
  },
  {
    value: '+20',
    label: 'Egypt',
    code: 'eg',
  },
  {
    value: '+503',
    label: 'El Salvador',
    code: 'sv',
  },
  {
    value: '+240',
    label: 'Equatorial Guinea',
    code: 'gq',
  },
  {
    value: '+291',
    label: 'Eritrea',
    code: 'er',
  },
  {
    value: '+372',
    label: 'Estonia',
    code: 'ee',
  },
  {
    value: '+251',
    label: 'Ethiopia',
    code: 'et',
  },
  {
    value: '+500',
    label: 'Falkland Islands (Malvinas)',
    code: 'fk',
  },
  {
    value: '+298',
    label: 'Faroe Islands',
    code: 'fo',
  },
  {
    value: '+679',
    label: 'Fiji',
    code: 'fj',
  },
  {
    value: '+358',
    label: 'Finland',
    code: 'fi',
  },
  {
    value: '+33',
    label: 'France',
    code: 'fr',
  },
  {
    value: '+594',
    label: 'French Guiana',
    code: 'gf',
  },
  {
    value: '+689',
    label: 'French Polynesia',
    code: 'pf',
  },
  {
    value: '+262',
    label: 'French Southern Territories',
    code: 'tf',
  },
  {
    value: '+241',
    label: 'Gabon',
    code: 'ga',
  },
  {
    value: '+220',
    label: 'Gambia',
    code: 'gm',
  },
  {
    value: '+995',
    label: 'Georgia',
    code: 'ge',
  },
  {
    value: '+49',
    label: 'Germany',
    code: 'de',
  },
  {
    value: '+233',
    label: 'Ghana',
    code: 'gh',
  },
  {
    value: '+350',
    label: 'Gibraltar',
    code: 'gi',
  },
  {
    value: '+30',
    label: 'Greece',
    code: 'gr',
  },
  {
    value: '+299',
    label: 'Greenland',
    code: 'gl',
  },
  {
    value: '+1473',
    label: 'Grenada',
    code: 'gd',
  },
  {
    value: '+590',
    label: 'Guadeloupe',
    code: 'gp',
  },
  {
    value: '+1671',
    label: 'Guam',
    code: 'gu',
  },
  {
    value: '+502',
    label: 'Guatemala',
    code: 'gt',
  },
  {
    value: '+44',
    label: 'Guernsey',
    code: 'gg',
  },
  {
    value: '+224',
    label: 'Guinea',
    code: 'gn',
  },
  {
    value: '+245',
    label: 'Guinea-Bissau',
    code: 'gw',
  },
  {
    value: '+592',
    label: 'Guyana',
    code: 'gy',
  },
  {
    value: '+509',
    label: 'Haiti',
    code: 'ht',
  },
  {
    value: '+672',
    label: 'Heard Island and Mcdonald Islands',
    code: 'hm',
  },
  {
    value: '+379',
    label: 'Holy See (Vatican City State)',
    code: 'va',
  },
  {
    value: '+504',
    label: 'Honduras',
    code: 'hn',
  },
  {
    value: '+852',
    label: 'Hong Kong',
    code: 'hk',
  },
  {
    value: '+36',
    label: 'Hungary',
    code: 'hu',
  },
  {
    value: '+354',
    label: 'Iceland',
    code: 'is',
  },
  {
    value: '+91',
    label: 'India',
    code: 'in',
  },
  {
    value: '+62',
    label: 'Indonesia',
    code: 'id',
  },
  {
    value: '+98',
    label: 'Iran, Islamic Republic of Persian Gulf',
    code: 'ir',
  },
  {
    value: '+964',
    label: 'Iraq',
    code: 'iq',
  },
  {
    value: '+353',
    label: 'Ireland',
    code: 'ie',
  },
  {
    value: '+44',
    label: 'Isle of Man',
    code: 'im',
  },
  {
    value: '+972',
    label: 'Israel',
    code: 'il',
  },
  {
    value: '+39',
    label: 'Italy',
    code: 'it',
  },
  {
    value: '+1876',
    label: 'Jamaica',
    code: 'jm',
  },
  {
    value: '+81',
    label: 'Japan',
    code: 'jp',
  },
  {
    value: '+44',
    label: 'Jersey',
    code: 'je',
  },
  {
    value: '+962',
    label: 'Jordan',
    code: 'jo',
  },
  {
    value: '+7',
    label: 'Kazakhstan',
    code: 'kz',
  },
  {
    value: '+254',
    label: 'Kenya',
    code: 'ke',
  },
  {
    value: '+686',
    label: 'Kiribati',
    code: 'ki',
  },
  {
    value: '+850',
    label: "Korea, Democratic People's Republic of Korea",
    code: 'kp',
  },
  {
    value: '+82',
    label: 'Korea, Republic of South Korea',
    code: 'kr',
  },
  {
    value: '+383',
    label: 'Kosovo',
    code: 'xk',
  },
  {
    value: '+965',
    label: 'Kuwait',
    code: 'kw',
  },
  {
    value: '+996',
    label: 'Kyrgyzstan',
    code: 'kg',
  },
  {
    value: '+856',
    label: 'Laos',
    code: 'la',
  },
  {
    value: '+371',
    label: 'Latvia',
    code: 'lv',
  },
  {
    value: '+961',
    label: 'Lebanon',
    code: 'lb',
  },
  {
    value: '+266',
    label: 'Lesotho',
    code: 'ls',
  },
  {
    value: '+231',
    label: 'Liberia',
    code: 'lr',
  },
  {
    value: '+218',
    label: 'Libyan Arab Jamahiriya',
    code: 'ly',
  },
  {
    value: '+423',
    label: 'Liechtenstein',
    code: 'li',
  },
  {
    value: '+370',
    label: 'Lithuania',
    code: 'lt',
  },
  {
    value: '+352',
    label: 'Luxembourg',
    code: 'lu',
  },
  {
    value: '+853',
    label: 'Macao',
    code: 'mo',
  },
  {
    value: '+389',
    label: 'Macedonia',
    code: 'mk',
  },
  {
    value: '+261',
    label: 'Madagascar',
    code: 'mg',
  },
  {
    value: '+265',
    label: 'Malawi',
    code: 'mw',
  },
  {
    value: '+60',
    label: 'Malaysia',
    code: 'my',
  },
  {
    value: '+960',
    label: 'Maldives',
    code: 'mv',
  },
  {
    value: '+223',
    label: 'Mali',
    code: 'ml',
  },
  {
    value: '+356',
    label: 'Malta',
    code: 'mt',
  },
  {
    value: '+692',
    label: 'Marshall Islands',
    code: 'mh',
  },
  {
    value: '+596',
    label: 'Martinique',
    code: 'mq',
  },
  {
    value: '+222',
    label: 'Mauritania',
    code: 'mr',
  },
  {
    value: '+230',
    label: 'Mauritius',
    code: 'mu',
  },
  {
    value: '+262',
    label: 'Mayotte',
    code: 'yt',
  },
  {
    value: '+52',
    label: 'Mexico',
    code: 'mx',
  },
  {
    value: '+691',
    label: 'Micronesia, Federated States of Micronesia',
    code: 'fm',
  },
  {
    value: '+373',
    label: 'Moldova',
    code: 'md',
  },
  {
    value: '+377',
    label: 'Monaco',
    code: 'mc',
  },
  {
    value: '+976',
    label: 'Mongolia',
    code: 'mn',
  },
  {
    value: '+382',
    label: 'Montenegro',
    code: 'me',
  },
  {
    value: '+1664',
    label: 'Montserrat',
    code: 'ms',
  },
  {
    value: '+212',
    label: 'Morocco',
    code: 'ma',
  },
  {
    value: '+258',
    label: 'Mozambique',
    code: 'mz',
  },
  {
    value: '+95',
    label: 'Myanmar',
    code: 'mm',
  },
  {
    value: '+264',
    label: 'Namibia',
    code: 'na',
  },
  {
    value: '+674',
    label: 'Nauru',
    code: 'nr',
  },
  {
    value: '+977',
    label: 'Nepal',
    code: 'np',
  },
  {
    value: '+31',
    label: 'Netherlands',
    code: 'nl',
  },
  {
    value: '+687',
    label: 'New Caledonia',
    code: 'nc',
  },
  {
    value: '+64',
    label: 'New Zealand',
    code: 'nz',
  },
  {
    value: '+505',
    label: 'Nicaragua',
    code: 'ni',
  },
  {
    value: '+227',
    label: 'Niger',
    code: 'ne',
  },
  {
    value: '+234',
    label: 'Nigeria',
    code: 'ng',
  },
  {
    value: '+683',
    label: 'Niue',
    code: 'nu',
  },
  {
    value: '+672',
    label: 'Norfolk Island',
    code: 'nf',
  },
  {
    value: '+1670',
    label: 'Northern Mariana Islands',
    code: 'mp',
  },
  {
    value: '+47',
    label: 'Norway',
    code: 'no',
  },
  {
    value: '+968',
    label: 'Oman',
    code: 'om',
  },
  {
    value: '+92',
    label: 'Pakistan',
    code: 'pk',
  },
  {
    value: '+680',
    label: 'Palau',
    code: 'pw',
  },
  {
    value: '+970',
    label: 'Palestinian Territory, Occupied',
    code: 'ps',
  },
  {
    value: '+507',
    label: 'Panama',
    code: 'pa',
  },
  {
    value: '+675',
    label: 'Papua New Guinea',
    code: 'pg',
  },
  {
    value: '+595',
    label: 'Paraguay',
    code: 'py',
  },
  {
    value: '+51',
    label: 'Peru',
    code: 'pe',
  },
  {
    value: '+63',
    label: 'Philippines',
    code: 'ph',
  },
  {
    value: '+64',
    label: 'Pitcairn',
    code: 'pn',
  },
  {
    value: '+48',
    label: 'Poland',
    code: 'pl',
  },
  {
    value: '+351',
    label: 'Portugal',
    code: 'pt',
  },
  {
    value: '+1939',
    label: 'Puerto Rico',
    code: 'pr',
  },
  {
    value: '+974',
    label: 'Qatar',
    code: 'qa',
  },
  {
    value: '+40',
    label: 'Romania',
    code: 'ro',
  },
  {
    value: '+7',
    label: 'Russia',
    code: 'ru',
  },
  {
    value: '+250',
    label: 'Rwanda',
    code: 'rw',
  },
  {
    value: '+262',
    label: 'Reunion',
    code: 're',
  },
  {
    value: '+590',
    label: 'Saint Barthelemy',
    code: 'bl',
  },
  {
    value: '+290',
    label: 'Saint Helena, Ascension and Tristan Da Cunha',
    code: 'sh',
  },
  {
    value: '+1869',
    label: 'Saint Kitts and Nevis',
    code: 'kn',
  },
  {
    value: '+1758',
    label: 'Saint Lucia',
    code: 'lc',
  },
  {
    value: '+590',
    label: 'Saint Martin',
    code: 'mf',
  },
  {
    value: '+508',
    label: 'Saint Pierre and Miquelon',
    code: 'pm',
  },
  {
    value: '+1784',
    label: 'Saint Vincent and the Grenadines',
    code: 'vc',
  },
  {
    value: '+685',
    label: 'Samoa',
    code: 'ws',
  },
  {
    value: '+378',
    label: 'San Marino',
    code: 'sm',
  },
  {
    value: '+239',
    label: 'Sao Tome and Principe',
    code: 'st',
  },
  {
    value: '+221',
    label: 'Senegal',
    code: 'sn',
  },
  {
    value: '+381',
    label: 'Serbia',
    code: 'rs',
  },
  {
    value: '+248',
    label: 'Seychelles',
    code: 'sc',
  },
  {
    value: '+232',
    label: 'Sierra Leone',
    code: 'sl',
  },
  {
    value: '+65',
    label: 'Singapore',
    code: 'sg',
  },
  {
    value: '+421',
    label: 'Slovakia',
    code: 'sk',
  },
  {
    value: '+386',
    label: 'Slovenia',
    code: 'si',
  },
  {
    value: '+677',
    label: 'Solomon Islands',
    code: 'sb',
  },
  {
    value: '+252',
    label: 'Somalia',
    code: 'so',
  },
  {
    value: '+27',
    label: 'South Africa',
    code: 'za',
  },
  {
    value: '+211',
    label: 'South Sudan',
    code: 'ss',
  },
  {
    value: '+500',
    label: 'South Georgia and the South Sandwich Islands',
    code: 'gs',
  },
  {
    value: '+34',
    label: 'Spain',
    code: 'es',
  },
  {
    value: '+94',
    label: 'Sri Lanka',
    code: 'lk',
  },
  {
    value: '+249',
    label: 'Sudan',
    code: 'sd',
  },
  {
    value: '+597',
    label: 'Suriname',
    code: 'sr',
  },
  {
    value: '+47',
    label: 'Svalbard and Jan Mayen',
    code: 'sj',
  },
  {
    value: '+268',
    label: 'Eswatini',
    code: 'sz',
  },
  {
    value: '+46',
    label: 'Sweden',
    code: 'se',
  },
  {
    value: '+41',
    label: 'Switzerland',
    code: 'ch',
  },
  {
    value: '+963',
    label: 'Syrian Arab Republic',
    code: 'sy',
  },
  {
    value: '+886',
    label: 'Taiwan',
    code: 'tw',
  },
  {
    value: '+992',
    label: 'Tajikistan',
    code: 'tj',
  },
  {
    value: '+255',
    label: 'Tanzania, United Republic of Tanzania',
    code: 'tz',
  },
  {
    value: '+66',
    label: 'Thailand',
    code: 'th',
  },
  {
    value: '+670',
    label: 'Timor-Leste',
    code: 'tl',
  },
  {
    value: '+228',
    label: 'Togo',
    code: 'tg',
  },
  {
    value: '+690',
    label: 'Tokelau',
    code: 'tk',
  },
  {
    value: '+676',
    label: 'Tonga',
    code: 'to',
  },
  {
    value: '+1868',
    label: 'Trinidad and Tobago',
    code: 'tt',
  },
  {
    value: '+216',
    label: 'Tunisia',
    code: 'tn',
  },
  {
    value: '+90',
    label: 'Turkey',
    code: 'tr',
  },
  {
    value: '+993',
    label: 'Turkmenistan',
    code: 'tm',
  },
  {
    value: '+1649',
    label: 'Turks and Caicos Islands',
    code: 'tc',
  },
  {
    value: '+688',
    label: 'Tuvalu',
    code: 'tv',
  },
  {
    value: '+256',
    label: 'Uganda',
    code: 'ug',
  },
  {
    value: '+380',
    label: 'Ukraine',
    code: 'ua',
  },
  {
    value: '+44',
    label: 'United Kingdom',
    code: 'gb',
  },
  {
    value: '+1',
    label: 'United States',
    code: 'us',
  },
  {
    value: '+598',
    label: 'Uruguay',
    code: 'uy',
  },
  {
    value: '+998',
    label: 'Uzbekistan',
    code: 'uz',
  },
  {
    value: '+678',
    label: 'Vanuatu',
    code: 'vu',
  },
  {
    value: '+58',
    label: 'Venezuela, Bolivarian Republic of Venezuela',
    code: 've',
  },
  {
    value: '+84',
    label: 'Vietnam',
    code: 'vn',
  },
  {
    value: '+1284',
    label: 'Virgin Islands, British',
    code: 'vg',
  },
  {
    value: '+1340',
    label: 'Virgin Islands, U.S.',
    code: 'vi',
  },
  {
    value: '+681',
    label: 'Wallis and Futuna',
    code: 'wf',
  },
  {
    value: '+967',
    label: 'Yemen',
    code: 'ye',
  },
  {
    value: '+260',
    label: 'Zambia',
    code: 'zm',
  },
  {
    value: '+263',
    label: 'Zimbabwe',
    code: 'zw',
  },
];
